<template>
  <v-container fluid justify-start>

    <!-- Header Toolbar -->
    <v-toolbar dense flat dark :color="appColor_Medium" class="mb-0">

      <app-back-button v-bind:color="appColor_Dark" />

      <v-toolbar-title>Abby Expressions</v-toolbar-title>
    </v-toolbar>

    <v-card>
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="12" sm="3">
            <v-select
              label="Language"
              v-model="languageId"
              :items="filteredLanguages"
              item-text="description"
              item-value="id"
              class="ml-3"
              hide-details
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <v-col cols="12" md="3">
            <v-btn outlined :color="appColor_Medium" @click="editCaregiver" class="ma-3">Caregiver Tabs</v-btn>
          </v-col>
          <v-col cols="12" md="3">
            <v-btn outlined :color="appColor_Medium" @click="editActivities" class="ma-3">Activities</v-btn>
          </v-col>
          <v-col cols="12" md="3">
            <v-btn outlined :color="appColor_Medium" @click="editTextResources" class="ma-3">Text Resources</v-btn>
          </v-col>
          <v-col cols="12" md="3">
            <v-btn outlined :color="appColor_Medium" @click="editInvitations" class="ma-3">Ambient Invitations</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Caregiver Edit Dialog -->
    <v-dialog
      v-model="caregiverDialog"
      max-width="450px"
      :persistent="true"
      >
      <loading slot="layout" :active.sync="isLoadingDialog" :can-cancel="false" loader="dots" :color="appColor_Progress"></loading>
      <v-card class="pb-2">
        <v-toolbar dense dark flat :color="appColor_Medium">
          <v-toolbar-title><v-icon>edit</v-icon> Caregiver Tabs</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pa-0 pt-2 ma-0">
          <v-container grid-list-md class="pt-0 pb-0">
            <form>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-select
                    v-model="mediaPathTypeId"
                    label="Caregiver Tab"
                    :items="mediaPathTypes"
                    item-value="id"
                    item-text="description"
                    hide-details
                  />
                </v-col>
              </v-row>

              <template v-if="caregiverEnglishExpressions !== null && caregiverExpressionsEdit !== null">
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="caregiverEnglishExpressions.description"
                      label="Description"
                      disabled
                      hide-details
                      >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="filteredCaregiverExpressions.description"
                      label="Description"
                      hide-details
                      ref="caregiverdescription"
                      >
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="caregiverEnglishExpressions.shortDescription"
                      label="Short Description"
                      disabled
                      hide-details
                      >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="filteredCaregiverExpressions.shortDescription"
                      label="Short Description"
                      hide-details
                      >
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="12">
                    <v-textarea
                      v-model="caregiverEnglishExpressions.longDescription"
                      label="Long Description"
                      disabled
                      hide-details
                      rows="3"
                      >
                    </v-textarea>
                  </v-col>
                  <v-col cols="12" sm="12">
                    <v-textarea
                      v-model="filteredCaregiverExpressions.longDescription"
                      label="Long Description"
                      hide-details
                      rows="3"
                      >
                    </v-textarea>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="caregiverEnglishExpressions.summaryLabel"
                      label="Summary Label"
                      disabled
                      hide-details
                      >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="filteredCaregiverExpressions.summaryLabel"
                      label="Summary Label"
                      hide-details
                      >
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="caregiverEnglishExpressions.summaryLabelPlural"
                      label="Summary Label Plural"
                      disabled
                      hide-details
                      >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="filteredCaregiverExpressions.summaryLabelPlural"
                      label="Summary Label Plural"
                      hide-details
                      >
                    </v-text-field>
                  </v-col>
                </v-row>

              </template>
            </form>
          </v-container>
        </v-card-text>

        <v-card-actions>

          <v-spacer />

          <v-btn text @click.native="closeCaregiverDialog">Cancel</v-btn>
          <v-btn :color="appColor_Dark" text @click.native="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Activities Dialog -->
    <v-dialog
      v-model="activitiesDialog"
      max-width="450px"
      :persistent="true"
      >
      <loading slot="layout" :active.sync="isLoadingDialog" :can-cancel="false" loader="dots" :color="appColor_Progress"></loading>
      <v-card class="pb-2">
        <v-toolbar dense dark flat :color="appColor_Medium">
          <v-toolbar-title><v-icon>edit</v-icon> Activities</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pa-0 pt-2 ma-0">
          <v-container grid-list-md class="pt-0 pb-0">
            <form>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-select
                    v-model="interactiveActivityTypeId"
                    label="Activity"
                    :items="activities"
                    item-value="id"
                    item-text="description"
                    hide-details
                  />
                </v-col>
              </v-row>

              <template v-if="activitiesEnglishExpressions !== null && activitiesExpressionEdit !== null">
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="filteredActivityExpression.description"
                      label="Description"
                      hide-details
                      ref="activitydescription"
                      >
                    </v-text-field>
                  </v-col>
                </v-row>

              </template>
            </form>
          </v-container>
        </v-card-text>

        <v-card-actions>

          <v-spacer />

          <v-btn text @click.native="closeActivitiesDialog">Cancel</v-btn>
          <v-btn :color="appColor_Medium" text @click.native="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Text Resources Dialog -->
    <v-dialog
      v-model="textResourcesDialog"
      max-width="450px"
      :persistent="true"
      >
      <loading slot="layout" :active.sync="isLoadingDialog" :can-cancel="false" loader="dots" :color="appColor_Progress"></loading>
      <v-card class="pb-2">
        <v-toolbar dense dark flat :color="appColor_Medium">
          <v-toolbar-title><v-icon>edit</v-icon> Text Resources</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pa-0 pt-2 ma-0">
          <v-container grid-list-md class="pt-0 pb-0">
            <form>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-select
                    v-model="textResourceTypeId"
                    label="Text Resource"
                    :items="textResources"
                    item-value="id"
                    item-text="description"
                    hide-details
                  />
                </v-col>
              </v-row>

              <template v-if="textResourcesEnglishExpressions !== null && textResourcesExpressionEdit !== null">
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="textResourcesEnglishExpressions.text"
                      label="Text"
                      disabled
                      hide-details
                      >
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="filteredTextResourceExpression.text"
                      label="Text"
                      hide-details
                      ref="resourcedescription"
                      >
                    </v-text-field>
                  </v-col>
                </v-row>

              </template>
            </form>
          </v-container>
        </v-card-text>

        <v-card-actions>

          <v-spacer />

          <v-btn text @click.native="closeTextResourcesDialog">Cancel</v-btn>
          <v-btn :color="appColor_Medium" text @click.native="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Ambient Invitations Dialog -->
    <v-dialog
      v-model="invitationsDialog"
      max-width="450px"
      :persistent="true"
      >
      <loading slot="layout" :active.sync="isLoadingDialog" :can-cancel="false" loader="dots" :color="appColor_Progress"></loading>
      <v-card class="pb-2">
        <v-toolbar dense dark flat :color="appColor_Medium">
          <v-toolbar-title><v-icon>edit</v-icon> Ambient Invitations</v-toolbar-title>
        </v-toolbar>

        <v-card-text class="pa-0 pt-2 ma-0">
          <v-container grid-list-md class="pt-0 pb-0">
            <form>
              <v-row>
                <v-col cols="12" sm="12">
                  <v-select
                    v-model="ambientInvitationId"
                    label="Ambient Invitations"
                    :items="invitations"
                    item-value="id"
                    item-text="message"
                    hide-details
                  />
                </v-col>
              </v-row>

              <template v-if="invitationsEnglishExpressions !== null && invitationsExpressionEdit !== null">
                <v-row>
                  <v-col cols="12" sm="12">
                    <v-text-field
                      v-model="filteredInvitationExpression.message"
                      label="Message"
                      hide-details
                      ref="invitationmessage"
                      >
                    </v-text-field>
                  </v-col>
                </v-row>

              </template>
            </form>
          </v-container>
        </v-card-text>

        <v-card-actions>

          <v-spacer />

          <v-btn text @click.native="closeInvitationsDialog">Cancel</v-btn>
          <v-btn :color="appColor_Medium" text @click.native="save">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import appService from '@/app.service'
import { mapGetters } from 'vuex'
import { AppColor, LanguageId } from '@/config.js'
import AppBackButton from '@/components/App/AppBackButton'

export default {
  name: 'AbbyExpressionManager',
  components: {
    AppBackButton
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {

      // colors
      appColor_Dark: AppColor.Dark,
      appColor_Medium: AppColor.Medium,
      
      appColor_Progress: AppColor.Progress,
      appColor_Abby: AppColor.KioskTypeAbby,
      appColor_Selected: AppColor.Selected,

      isLoading: true,
      isSaving: false,
      isLoadingDialog: false,

      caregiverDialog: false,
      activitiesDialog: false,
      textResourcesDialog: false,
      invitationsDialog: false,

      languageId: LanguageId.French,
      englishExpressions: [],
      expressions: [],

      caregiverExpressions: [],
      caregiverExpressionsEdit: [],

      activitiesExpressions: [],
      activitiesExpressionEdit: [],

      textResourcesExpressions: [],
      textResourcesExpressionEdit: [],

      invitationsExpressions: [],
      invitationsExpressionEdit: [],

      mediaPathTypeId: null,
      interactiveActivityTypeId: null,
      textResourceTypeId: null,
      ambientInvitationId: null,

      updateUrlSegment: null
    }
  },
  computed: {
    ...mapGetters(['languages']),
    languageExpressions () {
      if (this.expressions.length === 0) return []
      const self = this
      const expressions = self.expressions.filter(e => e.languageId === self.languageId)
      return expressions.length > 0
        ? expressions[0]
        : []
    },
    filteredLanguages () {
      return this.languages.filter(l => l.id !== LanguageId.English)
    },
    mediaPathTypes () {
      if (this.englishExpressions.length === 0) return []
      const self = this
      const pathTypes = self.englishExpressions.caregiver.map(e => { return {
        id: e.id,
        description: e.description
      }})
      return pathTypes
    },
    activities () {
      if (this.englishExpressions.length === 0) return []
      const self = this
      const activities = self.englishExpressions.activities.map(e => { return {
        id: e.id,
        description: e.description
      }})
      return activities
    },
    textResources () {
      if (this.englishExpressions.length === 0) return []
      const self = this
      const resources = self.englishExpressions.textResources.map(e => { return {
        id: e.id,
        description: e.description
      }})
      return resources
    },
    invitations () {
      if (this.englishExpressions.length === 0) return []
      const self = this
      const resources = self.englishExpressions.ambientInvitations.map(e => { return {
        id: e.id,
        message: e.message
      }})
      return resources
    },
    filteredCaregiverExpressions () {
      const self = this
      if (self.caregiverExpressionsEdit.length === 0) return []
      const expressions = self.caregiverExpressionsEdit.filter(e => e.id === self.mediaPathTypeId)
      return expressions.length > 0
        ? expressions[0]
        : []
    },
    filteredActivityExpression () {
      const self = this
      if (self.activitiesExpressionEdit.length === 0) return []
      const expressions = self.activitiesExpressionEdit.filter(e => e.id === self.interactiveActivityTypeId)
      return expressions.length > 0
        ? expressions[0]
        : []
    },
    filteredTextResourceExpression () {
      const self = this
      if (self.textResourcesExpressionEdit.length === 0) return []
      const expressions = self.textResourcesExpressionEdit.filter(e => e.id === self.textResourceTypeId)
      return expressions.length > 0
        ? expressions[0]
        : []
    },
    filteredInvitationExpression () {
      const self = this
      if (self.invitationsExpressionEdit.length === 0) return []
      const expressions = self.invitationsExpressionEdit.filter(e => e.id === self.ambientInvitationId)
      return expressions.length > 0
        ? expressions[0]
        : []
    },
    caregiverEnglishExpressions() {
      const self = this
      if (self.englishExpressions.length === 0) return []
      const expressions = self.englishExpressions.caregiver.filter(e => e.id === self.mediaPathTypeId)
      return expressions.length > 0
        ? expressions[0]
        : null
    },
    activitiesEnglishExpressions() {
      const self = this
      if (self.englishExpressions.length === 0) return []
      const expressions = self.englishExpressions.activities.filter(e => e.id === self.interactiveActivityTypeId)
      return expressions.length > 0
        ? expressions[0]
        : null
    },
    textResourcesEnglishExpressions() {
      const self = this
      if (self.englishExpressions.length === 0) return []
      const expressions = self.englishExpressions.textResources.filter(e => e.id === self.textResourceTypeId)
      return expressions.length > 0
        ? expressions[0]
        : null
    },
    invitationsEnglishExpressions() {
      const self = this
      if (self.englishExpressions.length === 0) return []
      const expressions = self.englishExpressions.ambientInvitations.filter(e => e.id === self.ambientInvitationId)
      return expressions.length > 0
        ? expressions[0]
        : null
    }
  },
  methods: {
    loadData () {
      const self = this
      self.isLoading = true
      appService.getAbbyExpressions().then(data => {
        if (data.errorSeverity > 0) {
          self.handleError(data)
        } else {
          self.englishExpressions = data.expressions.filter(e => e.languageId === LanguageId.English)[0]
          self.expressions = data.expressions.filter(e => e.languageId !== LanguageId.English)
          
          self.mediaPathTypeId = self.mediaPathTypes.length > 0
            ? self.mediaPathTypes[0]
            : null
          self.interactiveActivityTypeId = self.activities.length > 0
            ? self.activities[0]
            : null

          self.caregiverExpressions = self.cloneCaregiverExpressions(self.languageExpressions.caregiver)
          self.activitiesExpressions = self.cloneActivitiesExpressions(self.languageExpressions.activities)
          self.textResourcesExpressions = self.cloneTextResourcesExpressions(self.languageExpressions.textResources)
          self.invitationsExpressions = self.cloneInvitationsExpressions(self.languageExpressions.ambientInvitations)
        }
        self.isLoading = false
      }).catch(e => { self.handleCriticalError(e) })
    },

    editCaregiver () {
      const self = this
      self.updateUrlSegment = 'mediapathtypes'
      self.mediaPathTypeId = self.mediaPathTypes.length > 0
        ? self.mediaPathTypes[0].id
        : null

      self.caregiverExpressionsEdit = self.cloneCaregiverExpressions(self.caregiverExpressions)
      self.isLoadingDialog = true
      self.caregiverDialog = true
      setTimeout(() => {
        self.isLoadingDialog = false
      }, 100)
    },

    editActivities () {
      const self = this
      self.updateUrlSegment = 'interactiveactivities'
      self.interactiveActivityTypeId = self.activities.length > 0
        ? self.activities[0].id
        : null

      self.activitiesExpressionEdit = self.cloneActivitiesExpressions(self.activitiesExpressions)
      self.isLoadingDialog = true
      self.activitiesDialog = true
      setTimeout(() => {
        self.isLoadingDialog = false
      }, 100)
    },

    editTextResources () {
      const self = this
      self.updateUrlSegment = 'textresources'
      self.textResourceTypeId = self.textResources.length > 0
        ? self.textResources[0].id
        : null

      self.textResourcesExpressionEdit = self.cloneTextResourcesExpressions(self.textResourcesExpressions)
      self.isLoadingDialog = true
      self.textResourcesDialog = true
      setTimeout(() => {
        self.isLoadingDialog = false
      }, 100)
    },

    editInvitations () {
      const self = this
      self.updateUrlSegment = 'ambientinvitations'
      self.ambientInvitationId = self.invitations.length > 0
        ? self.invitations[0].id
        : null

      self.invitationsExpressionEdit = self.cloneInvitationsExpressions(self.invitationsExpressions)
      self.isLoadingDialog = true
      self.invitationsDialog = true
      setTimeout(() => {
        self.isLoadingDialog = false
      }, 100)
    },

    cloneCaregiverExpressions (expressions) {
      var items = []
      expressions.forEach(e => {
        items.push(this.getCaregiverModel(e))
      })
      return items
    },

    cloneActivitiesExpressions (expressions) {
      var items = []
      expressions.forEach(e => {
        items.push(this.getActivitiesModel(e))
      })
      return items
    },

    cloneTextResourcesExpressions (expressions) {
      var items = []
      expressions.forEach(e => {
        items.push(this.getTextResourcesModel(e))
      })
      return items
    },

    cloneInvitationsExpressions (expressions) {
      var items = []
      expressions.forEach(e => {
        items.push(this.getInvitationsModel(e))
      })
      return items
    },

    save () {
      const self = this
      self.$validator.validateAll().then(valid => {
        if (valid) {
          self.isSaving = true
          
          var updateExpressions = []
          switch (self.updateUrlSegment)
          {
            case "mediapathtypes":
              updateExpressions = self.caregiverExpressionsEdit
              break
            case "interactiveactivities":
              updateExpressions = self.activitiesExpressionEdit
              break
            case "textresources":
              updateExpressions = self.textResourcesExpressionEdit
              break
            case "ambientinvitations":
              updateExpressions = self.invitationsExpressionEdit
              break
          }

          appService.updateAbbyExpressions(self.languageId, self.updateUrlSegment, updateExpressions).then((data) => {
            if (data.errorSeverity !== null) {
              self.handleError(data)
            }
            self.isSaving = false

            switch (self.updateUrlSegment)
            {
              case "mediapathtypes":
                self.caregiverExpressions = self.cloneCaregiverExpressions(self.caregiverExpressionsEdit)
                self.closeCaregiverDialog()
                break
              case "interactiveactivities":
                self.activitiesExpressions = self.cloneActivitiesExpressions(self.activitiesExpressionEdit)
                self.closeActivitiesDialog()
                break
              case "textresources":
                self.textResourcesExpressions = self.cloneTextResourcesExpressions(self.textResourcesExpressionEdit)
                self.closeTextResourcesDialog()
                break
              case "ambientinvitations":
                self.invitationsExpressions = self.cloneInvitationsExpressions(self.invitationsExpressionEdit)
                self.closeInvitationsDialog()
                break
            }
          }).catch(e => { self.handleCriticalError(e) })
        }
      })
    },

    getCaregiverModel (e) {
      return {
        id: e.id,
        description: e.description,
        shortDescription: e.shortDescription,
        longDescription: e.longDescription,
        summaryLabel: e.summaryLabel,
        summaryLabelPlural: e.summaryLabelPlural
      }
    },

    getActivitiesModel (e) {
      return {
        id: e.id,
        description: e.description
      }
    },

    getTextResourcesModel (e) {
      return {
        id: e.id,
        description: e.description,
        text: e.text
      }
    },

    getInvitationsModel (e) {
      return {
        id: e.id,
        message: e.message
      }
    },

    closeCaregiverDialog () {
      const self = this
      self.caregiverDialog = false
      setTimeout(() => {
        self.isLoadingDialog = false
      }, 300)
    },

    closeActivitiesDialog () {
      const self = this
      self.activitiesDialog = false
      setTimeout(() => {
        self.isLoadingDialog = false
      }, 300)
    },

    closeTextResourcesDialog () {
      const self = this
      self.textResourcesDialog = false
      setTimeout(() => {
        self.isLoadingDialog = false
      }, 300)
    },

    closeInvitationsDialog () {
      const self = this
      self.invitationsDialog = false
      setTimeout(() => {
        self.isLoadingDialog = false
      }, 300)
    },

    handleError (result) {
      this.$error.show({
        title: result.errorSeverity === 0
                      ? 'Validation Failed'
                      : 'Internal Error',
        text: result.errorMessage,
        severity: result.errorSeverity
      })
    }
  },
  created() {
    this.loadData()
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
  },
  watch: {
    caregiverDialog (val) {
      if (val) {
        const self = this
        setTimeout(() => {
          // set focus to description input in the edit dialog
          self.$refs.caregiverdescription.focus()
        }, 300)
      } else {
        this.closeCaregiverDialog()
      }
    },
    activitiesDialog (val) {
      if (val) {
        const self = this
        setTimeout(() => {
          // set focus to description input in the edit dialog
          self.$refs.activitydescription.focus()
        }, 300)
      } else {
        this.closeActivitiesDialog()
      }
    },
    textResourcesDialog (val) {
      if (val) {
        const self = this
        setTimeout(() => {
          // set focus to description input in the edit dialog
          self.$refs.resourcedescription.focus()
        }, 300)
      } else {
        this.closeTextResourcesDialog()
      }
    },
    invitationsDialog (val) {
      if (val) {
        const self = this
        setTimeout(() => {
          // set focus to description input in the edit dialog
          self.$refs.invitationmessage.focus()
        }, 300)
      } else {
        this.closeInvitationsDialog()
      }
    }
  }
}
</script>

